<template>
    <div class="kiaf-login-view-right-mode">
        <div class="background-video" v-if="!onlyCasLogin()">
            <img v-if="customize.images.bg" :src="customize.images.bg" />
            <video v-else :src="videoUrl" autoplay muted></video>
        </div>
        <div class="login-main" v-if="!onlyCasLogin()">
            <img class="kedacom-logo" :src="customize.images.logo">
            <div class="police-logo">
                <img :src="customize.images.policelogo">
            </div>
            <div class="welcome">
                <img :src="customize.images.welcome">
            </div>

            <kc-form class="login-form" :model="models" ref="loginForm">
                <kc-form-item prop="username" class="login-input">
					<span class="input-name"
                          @click="usernameFocus"
                          :class="!userNameInputFocus && !models.username ? 'float' : ''">用户名
					</span>
                    <kc-input  v-model="models.username" auto-complete="off" name="userText" class="is-hidden"></kc-input>
                    <kc-input
                            ref="username"
                            size="mini"
                            @keydown.native.enter="userLogin()"
                            v-model="models.username"
                            auto-complete="off"
                            :autofocus="true"
                            name="usernameInput"
                            clearable>
                    </kc-input>
                    <div class="bottom-line"></div>
                    <div class="bottom-line-focus" :class="userNameInputFocus ? 'focus' : ''"></div>
                </kc-form-item>

                <kc-form-item prop="password" class="login-input">
					<span class="input-name"
                          @click="passwordFocus"
                          :class="!passwordInputFocus && !models.password ? 'float' : ''">密码
					</span>
                    <kc-input  type="password" v-model="models.password" auto-complete="off" name="passText" class="is-hidden"></kc-input>
                    <kc-input
                            ref="password"
                            size="mini"
                            @keydown.native.enter="userLogin()"
                            type="password"
                            v-model="models.password"
                            auto-complete="off"
                            name="pwdInput"
                            clearable>
                    </kc-input>
                    <div class="bottom-line"></div>
                    <div class="bottom-line-focus"
                         :style="{'background-color': errorMsg ? '#FF2E63' : '#1CD76E'}"
                         :class="passwordInputFocus || errorMsg ? 'focus' : ''">
                    </div>
                </kc-form-item>

                <span class="error-msg">{{errorMsg}}</span>

                <span class="remember-user"
                      @click="rememberUser = !rememberUser">
					<i class="kedaIconfont" :class="rememberUser ? 'KD-duigou' : 'KD-gongjud'"></i>记住用户名
				</span>
                <span class="remember-user casLoginBtn" @click="casLogin()" v-if="bothCasLogin()" id="casLoginBtn">{{customize.labels.casLogin}}<i class="kc-icon-arrow-right"></i></span>
                <div class="button-bg">
                    <kc-button
                            round
                            type="primary"
                            @click="userLogin()" id="pwdLoginBtn"
                            :loading="loading">登录{{loading?'中':''}}
                    </kc-button>
                </div>
                <div class="downloadBox" v-if="browserDownloadUrl">
                    <kc-select v-model="browserVersion" placeholder="请选择">
                        <kc-option
                                v-for="item in browserOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </kc-option>
                    </kc-select>
                    <kc-button
                            round
                            type="primary"
                            plain
                            @click="downloadBrowser()"
                    >下载
                    </kc-button>
                </div>
            </kc-form>

            <footer>{{customize.labels.copyright}}</footer>
        </div>
        <kc-modal
                v-if="forceUpdatePwd"
                title="请修改相关密码"
                width="20rem"
                :visible.sync="forceUpdatePwd"
                v-model:visible="forceUpdatePwd"
                :close-on-click-modal="false"
                class="change-password"
                :fullscreen-bg="true"
                @close="handlePwdUpdated"
        >
            <kiaf-person-setting ref="updatePwd" hideHomePage="true" :force-update-pwd="true" @pwdUpdated="handlePwdUpdated"></kiaf-person-setting>
            <kc-button
                    round
                    type="primary"
                    plain
                    @click="savePassword()"
            >保存
            </kc-button>
        </kc-modal>
    </div>
</template>

<script>
  import mixins from '../mixins/login';
  import useDownloadBrowser from '../mixins/useDownloadBrowser';

  export default {
    mixins: [mixins],
    data() {
      return {
        userNameInputFocus: false,
        passwordInputFocus: false,
        errorMsg: ''
      };
    },
    methods: {
      usernameFocus () {
        if (!this.userNameInputFocus && !this.models.username) {
          this.$refs.username.focus();
        }
      },
      passwordFocus () {
        if (!this.passwordInputFocus && !this.models.password) {
          this.$refs.password.focus();
        }
      },
      handleChange() {
      }
    },
    computed: {
      videoUrl(){
        if(this.customize && this.customize.videos && this.customize.videos.bg){
          return this.customize.videos.bg;
        } else {
          return '';
        }
      }
    },
    setup() {
      return {
        ...useDownloadBrowser()
      };
    },
    created() {
      if (!this.customize.images.policelogo) {
        this.$set(this.customize.images, 'policelogo', require('../../../../static/kiaf-baseui/images/police-logo.png'));
      }
      if (!this.customize.images.logo) {
        this.$set(this.customize.images, 'logo', require('../../../../static/kiaf-baseui/images/kedacom-logo.png'));
      }
      if (!this.customize.images.welcome) {
        this.$set(this.customize.images, 'welcome', require('../../../../static/kiaf-baseui/images/welcome.png'));
      }
    }
  };
</script>
<style scoped>
    .is-hidden {
        position: absolute;
        left: -10000px;
        top: -10000px;
    }
</style>
<style lang="scss">
    @import "index.scss";
</style>
